import { u2000IsValidEmail } from '../../u2000Core/tools/U2000EmailHelper';
import { unmaskPhone } from '../../u2000Core/tools/U2000MaskUtils';
import { NS } from '../U3120Constants';
import type { U3120CustomerContact } from '../U3120Service';
import type { U3120Translate } from './U3120CustomerValidation';

const ns = { ns: NS };

export function u3120FindDuplicateContactName(
  contacts: U3120CustomerContact[],
  contactName: string | undefined,
  excludeId?: string,
): U3120CustomerContact | undefined {
  if (!contactName) {
    return undefined;
  }
  return contacts.find((item) => item.contactName === contactName && item.id !== excludeId);
}

export function u3120ValidateCustomerContact(
  customerContact: U3120CustomerContact,
  existingContacts: U3120CustomerContact[],
  t: U3120Translate,
): Record<string, string> {
  const result: Record<string, string> = {};
  if (!customerContact.contactName || customerContact.contactName.trim() === '') {
    result.contactName = t('errContactNameRequired', ns);
  }
  if (!customerContact.contactType || !customerContact.contactType.id || customerContact.contactType.id === '') {
    result['contactType.id'] = t('errContactTypeRequired', ns);
  }
  if (customerContact.phone1 && unmaskPhone(customerContact.phone1).length !== 10) {
    result.phone1 = t('errPhoneNumberInvalid', ns);
  }
  if (customerContact.phone2 && unmaskPhone(customerContact.phone2).length !== 10) {
    result.phone2 = t('errPhoneNumberInvalid', ns);
  }
  if (customerContact.email && !u2000IsValidEmail(customerContact.email)) {
    result.email = t('errEmailInvalid', ns);
  }
  const duplicate = u3120FindDuplicateContactName(existingContacts, customerContact.contactName, customerContact.id);
  if (duplicate) {
    result.contactName = t('errCustomerContactDuplicate', ns);
  }
  return result;
}
